import { CategoryApplianceIcon } from '@/core/tamagoshiTailwind/icons/CategoryApplianceIcon';
import { CategoryBathroomIcon } from '@/core/tamagoshiTailwind/icons/CategoryBathroomIcon';
import { CategoryConstructionIcon } from '@/core/tamagoshiTailwind/icons/CategoryConstructionIcon';
import { CategoryElectricityIcon } from '@/core/tamagoshiTailwind/icons/CategoryElectricityIcon';
import { CategoryEnergyRenovationIcon } from '@/core/tamagoshiTailwind/icons/CategoryEnergyRenovationIcon';
import { CategoryFurnitureIcon } from '@/core/tamagoshiTailwind/icons/CategoryFurnitureIcon';
import { CategoryGardenIcon } from '@/core/tamagoshiTailwind/icons/CategoryGardenIcon';
import { CategoryHardwareIcon } from '@/core/tamagoshiTailwind/icons/CategoryHardwareIcon';
import { CategoryKitchenIcon } from '@/core/tamagoshiTailwind/icons/CategoryKitchenIcon';
import { CategoryLightingIcon } from '@/core/tamagoshiTailwind/icons/CategoryLightingIcon';
import { CategoryPaintingIcon } from '@/core/tamagoshiTailwind/icons/CategoryPaintingIcon';
import { CategoryPetShopIcon } from '@/core/tamagoshiTailwind/icons/CategoryPetShopIcon';
import { CategoryPlumbingIcon } from '@/core/tamagoshiTailwind/icons/CategoryPlumbingIcon';
import { CategoryTilingIcon } from '@/core/tamagoshiTailwind/icons/CategoryTilingIcon';
import { CategoryTimberIcon } from '@/core/tamagoshiTailwind/icons/CategoryTimberIcon';
import { CategoryToolsIcon } from '@/core/tamagoshiTailwind/icons/CategoryToolsIcon';
import { TamagoshiIconComponent } from '@/core/tamagoshiTailwind/interfaces';

const FAMILY_ID_ICONS: Record<number, TamagoshiIconComponent> = {
  1: CategoryBathroomIcon,
  116: CategoryKitchenIcon,
  173: CategoryLightingIcon,
  205: CategoryElectricityIcon,
  323: CategoryTilingIcon,
  463: CategoryToolsIcon,
  585: CategoryHardwareIcon,
  673: CategoryPlumbingIcon,
  796: CategoryApplianceIcon,
  823: CategoryGardenIcon,
  3943: CategoryConstructionIcon,
  4203: CategoryPetShopIcon,
  4605: CategoryFurnitureIcon,
  4899: CategoryPaintingIcon,
  5200: CategoryTimberIcon,
  5798: CategoryEnergyRenovationIcon,
};

export const getFamilyIcon = (id?: number): TamagoshiIconComponent => {
  return id && Object.keys(FAMILY_ID_ICONS).includes(id.toString())
    ? FAMILY_ID_ICONS[id]
    : CategoryFurnitureIcon;
};
